export const formatPhone = (phoneNumber: string) => {
  return phoneNumber.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 ($2) $3-$4-$5');
};

export const cropPhone = (phoneNumber: string) => {
  return phoneNumber.replace(/^\+?7(\d{3})(\d{3})(\d{2})(\d{2})$/, '+7 $1 $2-$3...');
};
